





















































































































































import { Component, Prop } from 'vue-property-decorator';
import AvaivaledVue from '@/components/avaivaled.vue';
import { UserTypes } from '@/enums/userTypes';
import Axios from 'axios';
import DialogWrapper from '@/components/dialogWrapper.vue';


import { UnivaPayTokenResponse } from '@/models/univaPayTokenResponse';
import {
  UnivaPayResponse,
  UnivaPayCreditcard,
} from '@/models/univaPayResponse';
import { UnivaPayRegisterCreditcardRequest } from '@/models/univaPayRegisterCreditcardRequest';
import { OperationTimeoutError } from '@/errors/OperationTimeoutError';

interface CreditcardEdit extends UnivaPayCreditcard {
  isEdit: boolean;
}

interface UnivapayCheckoutResult {
  token?: string;
  id?: string;
}

interface NormalizedError {
  name: string;
  message: string;
  code?: number;
  httpStatus?: number;
  isNetworkError: boolean;
  isTimeout: boolean;
}

interface ClientLogProperties {
  [key: string]: string | number | boolean | null | undefined;
}

type RegistrationStatus =
  | 'idle'
  | 'tokenizing'
  | 'registering'
  | 'checking';

type WebhookRegistrationStatus =
  | 'successful'
  | 'failed'
  | 'pending';

type RegistrationCompletionResult =
  | {
      status: 'successful';
      source: 'submit' | 'webhook';
    }
  | {
      status: 'failed';
      source: 'submit' | 'webhook';
      error?: unknown;
    }
  | {
      status: 'timeout';
      source: 'webhook';
    }
  | {
      status: 'cancelled';
      source: 'webhook';
    };

// @ts-ignore
@Component({})
export default class extends AvaivaledVue {
  @Prop({ required: true })
  public loading!: boolean;

  /**
   * UnivaPay CheckoutスクリプトURL。
   */
  private readonly univapayCheckoutScriptUrl =
    'https://widget.univapay.com/client/checkout.js';

  /**
   * UnivaPayのsubmit完了、およびWebhookによる
   * 登録結果の確認を待つ最大時間。
   *
   * SMS認証やカード会社アプリでの認証、
   * Flutter WebViewへの復帰時間を考慮して10分とする。
   */
  private readonly checkoutSubmitTimeoutMs = 10 * 60 * 1000;

  /**
   * submit処理が失敗した後、
   * Webhookによる成功通知を待つ最大時間。
   */
  private readonly checkoutSubmitFailedTimeoutMs = 30 * 1000;

  /**
   * Checkout iframeの生成を待つ最大時間。
   */
  private readonly checkoutInitializeTimeoutMs = 15 * 1000;

  /**
  * Webhookが先に失敗した場合に、
  * より詳細なsubmit結果を待つ時間。
  */
  private readonly webhookFailureSubmitWaitMs = 10 * 1000;

  /**
   * 自システムへの登録APIの最大試行回数。
   *
   * 初回実行を含むため、4の場合は最大4回呼び出す。
   */
  private readonly registerMaxAttempts = 4;

  private creditcard: UnivaPayCreditcard | null = null;

  private univapayToken = '';

  private univapayMailaddress = '';

  /**
   * Checkout要素を再描画するためのキー。
   */
  private checkoutRenderKey = 0;

  /**
   * Checkoutの初期化中か。
   */
  private checkoutInitializing = false;

  /**
   * Checkout iframeの生成が完了したか。
   */
  private checkoutReady = false;

  /**
   * 登録処理中か。
   */
  private isSubmitting = false;

  /**
   * 現在の登録処理状態。
   */
  private registrationStatus: RegistrationStatus = 'idle';

  /**
   * 現在実行している登録操作の識別子。
   */
  private currentOperationId: string | null = null;

  /**
   * コンポーネント破棄中か。
   */
  private isDestroying = false;

  /**
   * Webhookによる登録状態を確認する間隔。
   */
  private readonly registrationPollingIntervalMs =
    2 * 1000;

  /**
   * 登録状態ポーリングの識別子。
   *
   * 新しい処理開始時や処理完了時に値を変更し、
   * 古いポーリングを停止させる。
   */
  private registrationPollingToken = 0;

  private readonly errorCodes = new Map<number, string>([
    [301, 'カード番号のエラーです。'],
    [302, '不正な有効期限（月）です。'],
    [303, '不正な有効期限（年）です。'],
    [304, '有効期限切れです。'],
    [305, 'セキュリティーコードに関するエラーです。'],
    [306, 'カードが拒否されました(認証審査エラー)。失敗理由についてはカード発行会社へお問い合わせください。'],
    [307, '不正なカードです。'],
    [308, 'このカードはカード会社から承認が下りていません。詳細は消費者よりカード会社へお問い合わせください。'],
    // [309, '一般エラーが発生しました。詳細情報は管理画面で確認できます。'],
    // [310, '消費者データが不正です(無効なリクエストデータ)。加盟店のリクエストに誤りがある可能性があります。'],
    [311, '短期間に同一カードでの課金が多すぎます。しばらく待ってから再試行してください。'],
    // [312, 'この課金はキャンセルできません。'],
    // [313, 'オーソリの期限が切れました(課金のキャプチャ時)。'],
    // [314, 'このカードは盗難されたものとして報告されたか、発行会社によって無効化されました。加盟店は利用者のこのカードを差し押さえてください。'],
    [315, 'カード発行会社へお問い合わせください。'],
    [316, '名義人の姓は必須です。'],
    // [317, '部分的なキャプチャはサポートされていません。'],
    // [318, '部分的な返金はサポートされていません。'],
    // [319, '不正行為の疑いがあります(セキュリティ制限)。'],
    [320, '銀行側のシステムでエラーが発生しました。'],
    // [321, 'ダイナミックディスクリプタはサポートされていません。'],
    [322, 'バーコード/QRコードが無効です。'],
    [323, 'バーコード/QRコードの有効期限が切れています。'],
    [324, 'このバーコード/QRコードは既に処理済みです。'],
    [325, 'このバーコード/QRコードは現在処理中です。'],
    // [326, 'リスクプロファイルが高いため拒否されました。'],
    [327, '決済期限（タイムアウトは5分）が切れています。'],
    // [328, '復帰に失敗しました。手動による介入が必要です。'],
    // [329, '返金に失敗しました。'],
    [330, '残高が不足しています。'],
    // [331, 'メタデータフィールドの値が無効または不足しています。'],
    [332, '国境を越えた取引は許可されていません：身分証明書がありません。'],
    [333, '国境を越えた取引は許可されていません：電話番号がありません。'],
    [334, '国境を越えた取引は許可されていません：承認されていない支払方法です。'],
    [335, '国境を越えた取引は許可されていません：名前がありません。'],
    // [336, 'この支払方法の決済制限を超えました。'],
    // [337, 'この加盟店の決済制限を超えました。'],
    // [338, '決済情報が見つかりません。'],
    // [339, '決済情報が重複しています。'],
    // [340, 'この消費者のリテールQRアカウントはゲートウェイによって拒否されました。'],
    // [341, 'この加盟店には、このゲートウェイに必要な情報が不足しています。'],
    [342, '国境を越えた取引は許可されていません： 承認されていない通貨です。'],
    [343, 'ゲートウェイでサーバーエラー(接続先システムエラー)が発生したため、支払いを処理できませんでした。しばらく待ってから再試行してください。'],
    [344, '選択した支払方法は、ゲートウェイにより一時的に利用できません。'],
    // [345, '支払いは既にキャンセルされています。'],
    [346, 'システムが遅延したため、支払い処理に時間がかかりキャンセルされました。しばらく待ってから再試行してください。'],
    // [351, '無効な取引です。'],
    [355, '指定された支払い区分（分割回数など）が非対応のカードです。'],
    [356, '3Dセキュアの登録がされていないカードです。'],
    [358, '3Dセキュア認証の処理に失敗しました。'],
    [359, '3Dセキュア認証の処理に失敗しました。'],
  ]);

  get studentId(): string {
    return this.$route.params.studentId;
  }

  get student(): unknown {
    return this.$store.state.student.selectedStudent;
  }

  get localLoading(): boolean {
    return this.loading;
  }

  set localLoading(value: boolean) {
    this.$emit('update:loading', value);
  }

  get isMini(): boolean {
    return (this as any).$mq === 'mini';
  }

  get isStudent(): boolean {
    return this.userRole === UserTypes.Student;
  }

  get univapayTokenApiUrl(): string {
    return this.isStudent
      ? '/api/univapay/token'
      : `/api/univapay/${this.studentId}/token`;
  }

  get univapayInfoApiUrl(): string {
    return this.isStudent
      ? '/api/univapay'
      : `/api/univapay/${this.studentId}`;
  }

  get univapayRegisterCreditcardUrl(): string {
    return this.isStudent
      ? '/api/univapay/register-creditcard'
      : `/api/univapay/${this.studentId}/register-creditcard`;
  }

  get univapayCreditcardApiUrl(): string {
    return this.isStudent
      ? '/api/univapay/creditcard'
      : `/api/univapay/${this.studentId}/creditcard`;
  }

  get univapayRegistrationStatusApiUrl(): string {
    return this.isStudent
      ? `/api/univapay/registration-status`
      : `/api/univapay/${this.studentId}/registration-status`;
  }

  private created(): void {
    this.localLoading = true;
  }

  private async mounted(): Promise<void> {
    this.addBrowserLifecycleEventListeners();

    try {
      await this.loadUnivaPayToken();
      await this.loadData();
    } catch (error) {
      this.logClientError(
        'component_initialize_failed',
        error,
        this.currentOperationId
      );

      await this.$router.push({
        name: 'Top',
      });

      return;
    } finally {
      this.localLoading = false;
    }
  }

  private beforeDestroy(): void {
    this.isDestroying = true;

    this.removeBrowserLifecycleEventListeners();
    this.cleanupCheckout();
  }

  /**
   * UnivaPay Checkout用のアプリトークンを取得する。
   */
  private async loadUnivaPayToken(): Promise<void> {
    const response = await Axios.get<UnivaPayTokenResponse>(
      this.univapayTokenApiUrl
    );

    this.univapayToken = response.data.token;

    /*
     * APIがメールアドレスを返す場合は設定する。
     *
     * this.univapayMailaddress = response.data.mailaddress;
     */

    this.logClientEvent(
      'univapay_app_token_loaded',
      null,
      {
        tokenLoaded: Boolean(this.univapayToken),
      }
    );
  }

  /**
   * 自システムに登録されているクレジットカード情報を取得する。
   */
  private async loadData(
    redirectOnError: boolean = true
  ): Promise<void> {
    try {
      const response = await Axios.get<UnivaPayResponse>(
        this.univapayInfoApiUrl,
        {
          dontDisplayErrorPage: true,
        }
      );

      this.creditcard = response.data.creditcard;

      this.logClientEvent(
        'creditcard_information_loaded',
        this.currentOperationId,
        {
          cardRegistered: Boolean(this.creditcard),
        }
      );
    } catch (error) {
      this.logClientError(
        'creditcard_information_load_failed',
        error,
        this.currentOperationId
      );

      if (redirectOnError) {
        await this.$router.push({
          name: 'Top',
        });
      }

      throw error;
    }
  }

  /**
   * カード追加ダイアログを開く。
   */
  private async onAdd(): Promise<void> {
    if (this.isSubmitting) {
      return;
    }

    const form: CreditcardEdit = {
      isEdit: false,
      cardId: '',
      number: '',
      expireMonth: '',
      expireYear: '',
    };

    this.resetCheckoutState();

    try {
      await (this.$refs.cardEdit as DialogWrapper).open({
        ...form,
      });
    } catch (error) {
      /*
       * DialogWrapperのキャンセルを例外として扱っている場合は、
       * ここではエラー表示しない。
       */
      this.logClientEvent(
        'creditcard_add_dialog_cancelled',
        this.currentOperationId
      );
    }
  }

  /**
   * カード編集ダイアログを開く。
   */
  private async onEdit(): Promise<void> {
    if (this.isSubmitting || !this.creditcard) {
      return;
    }

    const form: CreditcardEdit = {
      isEdit: true,
      cardId: this.creditcard.cardId,
      number: this.creditcard.number,
      expireMonth: this.creditcard.expireMonth,
      expireYear: this.creditcard.expireYear,
    };

    this.resetCheckoutState();

    try {
      await (this.$refs.cardEdit as DialogWrapper).open({
        ...form,
      });
    } catch (error) {
      this.logClientEvent(
        'creditcard_edit_dialog_cancelled',
        this.currentOperationId
      );
    }
  }

  /**
   * ダイアログが表示された後にUnivaPay Checkoutを初期化する。
   */
  private async onCardDialogOpened(): Promise<void> {
    if (this.isDestroying) {
      return;
    }

    this.checkoutInitializing = true;
    this.checkoutReady = false;

    try {
      await this.$nextTick();

      this.logClientEvent(
        'univapay_checkout_initialize_started',
        this.currentOperationId
      );

      await this.loadUnivaPayCheckoutScript();
      await this.waitForCheckoutIframe(
        this.checkoutInitializeTimeoutMs
      );

      this.checkoutReady = true;

      this.logClientEvent(
        'univapay_checkout_initialize_completed',
        this.currentOperationId
      );
    } catch (error) {
      this.checkoutReady = false;

      this.logClientError(
        'univapay_checkout_initialize_failed',
        error,
        this.currentOperationId
      );

      this.$notify.error({
        title: 'クレジットカード入力フォーム',
        message:
          '入力フォームを読み込めませんでした。ダイアログを閉じて、もう一度お試しください。',
        position: 'bottom-right',
      });
    } finally {
      this.checkoutInitializing = false;
    }
  }

  /**
   * カード登録ダイアログが閉じられた場合の後処理。
   */
  private onCardDialogClosed(): void {
    if (this.isSubmitting) {
      return;
    }

    this.cleanupCheckout();

    this.registrationStatus = 'idle';
    this.checkoutReady = false;
    this.checkoutInitializing = false;
    this.currentOperationId = null;

    this.logClientEvent(
      'creditcard_dialog_closed',
      null
    );
  }

  /**
   * Checkoutの状態を初期化する。
   */
  private resetCheckoutState(): void {
    this.cleanupCheckout();

    this.checkoutRenderKey++;
    this.checkoutInitializing = false;
    this.checkoutReady = false;
    this.registrationStatus = 'idle';
    this.currentOperationId = null;
  }

  /**
   * UnivaPay Checkoutスクリプトを読み込む。
   *
   * ダイアログを開くたびに読み込むことで、
   * 新しく生成されたdata-checkout要素を初期化させる。
   */
  private loadUnivaPayCheckoutScript(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const previousScripts = document.querySelectorAll<
        HTMLScriptElement
      >(
        'script[data-univapay-checkout-loader="true"]'
      );

      previousScripts.forEach((scp, _) => {
        scp.parentNode?.removeChild(scp);
      });

      const elScript = document.createElement('script');

      elScript.src = this.univapayCheckoutScriptUrl;
      elScript.type = 'text/javascript';
      elScript.async = true;
      elScript.setAttribute(
        'data-univapay-checkout-loader',
        'true'
      );

      elScript.onload = () => {
        elScript.onload = null;
        elScript.onerror = null;

        resolve();
      };

      elScript.onerror = () => {
        elScript.onload = null;
        elScript.onerror = null;

        reject(
          new Error(
            'UnivaPay Checkoutスクリプトの読み込みに失敗しました。'
          )
        );
      };

      document.head.appendChild(elScript);
    });
  }

  /**
   * Checkout iframeが生成されるまで待つ。
   */
  private async waitForCheckoutIframe(
    timeoutMs: number
  ): Promise<HTMLIFrameElement> {
    const startedAt = Date.now();

    while (Date.now() - startedAt < timeoutMs) {
      if (this.isDestroying) {
        throw new Error(
          'コンポーネントが破棄されたためCheckoutの初期化を中断しました。'
        );
      }

      const iframe =
        document.querySelector<HTMLIFrameElement>(
          '#checkout iframe'
        );

      if (iframe) {
        return iframe;
      }

      await this.wait(100);
    }

    throw new OperationTimeoutError(
      'UnivaPay Checkout iframeの生成がタイムアウトしました。'
    );
  }

  /**
   * クレジットカードを削除する。
   */
  private async onDelete(): Promise<void> {
    if (this.isSubmitting) {
      return;
    }

    try {
      await this.$confirm(
        'クレジットカードを削除します。よろしいですか？',
        'クレジットカード削除',
        {
          confirmButtonText: '削除',
          cancelButtonText: 'キャンセル',
          type: 'warning',
        }
      );
    } catch (error) {
      return;
    }

    this.isSubmitting = true;
    this.localLoading = true;

    const operationId = this.createOperationId();

    this.currentOperationId = operationId;

    this.logClientEvent(
      'creditcard_delete_started',
      operationId
    );

    try {
      await Axios.delete(
        this.univapayCreditcardApiUrl,
        {
          dontDisplayErrorPage: true,
          headers: {
            'X-Operation-Id': operationId,
          },
        }
      );

      await this.loadData(false);

      this.logClientEvent(
        'creditcard_delete_completed',
        operationId
      );

      this.$notify.success({
        title: 'クレジットカード削除',
        message:
          'クレジットカード情報を削除しました。',
        position: 'bottom-right',
      });
    } catch (error) {
      this.logClientError(
        'creditcard_delete_failed',
        error,
        operationId
      );

      this.$notify.error({
        title: 'クレジットカード削除',
        message:
          'クレジットカード情報の削除に失敗しました。',
        position: 'bottom-right',
      });
    } finally {
      this.localLoading = false;
      this.isSubmitting = false;
      this.currentOperationId = null;
    }
  }

  /**
   * クレジットカードの追加または変更を実行する。
   *
   * UnivaPay Checkoutのsubmit処理と、
   * Webhookによる登録状態のポーリングを並行実行する。
   */
  private async submitForm(
    isEdit: boolean
  ): Promise<void> {
    if (
      this.isSubmitting ||
      this.checkoutInitializing ||
      !this.checkoutReady
    ) {
      return;
    }

    const modeText = isEdit ? '変更' : '登録';
    const operationId = this.createOperationId();

    this.currentOperationId = operationId;
    this.isSubmitting = true;
    this.registrationStatus = 'tokenizing';

    /*
    * 新しいポーリング処理を開始するための識別子。
    */
    const pollingToken =
      ++this.registrationPollingToken;

    this.logClientEvent(
      'creditcard_registration_started',
      operationId,
      {
        isEdit,
      }
    );

    try {
      /*
      * submitが失敗した時刻。
      *
      * nullの間はsubmit処理中として、
      * 通常の10分タイムアウトを使用する。
      */
      let submitFailedAt: number | null = null;

      const submitTask =
        this.registerCreditcardBySubmit(
          isEdit,
          operationId
        ).then((res) => {
          if (res.status === 'failed') {
            submitFailedAt = Date.now();

            this.logClientEvent(
              'creditcard_registration_submit_failure_wait_started',
              operationId,
              {
                timeoutMilliseconds:
                  this.checkoutSubmitFailedTimeoutMs,
              }
            );
          }

          return res;
        });

      const webhookTask =
        this.pollRegistrationStatus(
          operationId,
          pollingToken,
          () => submitFailedAt
        );

      const result =
        await this.waitForRegistrationCompletion(
          submitTask,
          webhookTask
        );

      if (result.status !== 'successful') {
        if (result.status === 'timeout') {
          throw new OperationTimeoutError(
            'クレジットカードの登録結果を確認できませんでした。'
          );
        }

        if (result.status === 'cancelled') {
          return;
        }

        throw (
          result.error ??
          new Error(
            result.source === 'webhook'
              ? '3Dセキュア認証またはリカーリングトークンの登録に失敗しました。'
              : 'クレジットカード情報の登録に失敗しました。'
          )
        );
      }

      this.registrationStatus = 'checking';
      this.localLoading = true;

      /*
      * submit経由でもWebhook経由でも、
      * 最終的には自システムのカード情報を再取得する。
      */
      await this.loadData(false);

      if (!this.creditcard) {
        throw new Error(
          '登録処理は成功しましたが、クレジットカード情報を確認できませんでした。'
        );
      }

      this.logClientEvent(
        'creditcard_registration_completed',
        operationId,
        {
          isEdit,
          completedBy: result.source,
        }
      );

      /*
      * 自システムへの反映を確認してから
      * ダイアログを閉じる。
      */
      (this.$refs.cardEdit as DialogWrapper).submit();

      this.$notify.success({
        title: `クレジットカード${modeText}`,
        message:
          `クレジットカード情報を${modeText}しました。`,
        position: 'bottom-right',
      });
    } catch (error) {
      this.logClientError(
        'creditcard_registration_failed',
        error,
        operationId,
        {
          isEdit,
          phase: this.registrationStatus,
        }
      );

      await this.displayRegistrationError(
        error,
        modeText
      );
    } finally {
      /*
      * 実行中のポーリングを停止させる。
      */
      if (
        this.registrationPollingToken ===
        pollingToken
      ) {
        this.registrationPollingToken++;
      }

      this.localLoading = false;
      this.isSubmitting = false;
      this.registrationStatus = 'idle';
      this.currentOperationId = null;
    }
  }

  /**
   * UnivaPay Checkoutのsubmit結果を使用して
   * 自システムへクレジットカードを登録する。
   */
  private async registerCreditcardBySubmit(
    isEdit: boolean,
    operationId: string
  ): Promise<RegistrationCompletionResult> {
    try {
      const recurringToken =
        await this.createRecurringToken(
          operationId
        );

      this.registrationStatus = 'registering';

      const request: UnivaPayRegisterCreditcardRequest = {
        recurringToken,
      };

      await this.registerCreditcardWithRetry(
        request,
        operationId
      );

      this.logClientEvent(
        'creditcard_registration_submit_completed',
        operationId,
        {
          isEdit,
        }
      );

      return {
        status: 'successful',
        source: 'submit',
      };
    } catch (error) {
      /*
      * submit側で失敗しても、この時点では
      * 画面全体を失敗にはしない。
      *
      * WebViewがUnivaPayの結果イベントを
      * 受信できなかっただけで、Webhook側では
      * successfulになる可能性があるため。
      */
      this.logClientError(
        'creditcard_registration_submit_failed',
        error,
        operationId,
        {
          isEdit,
        }
      );

      return {
        status: 'failed',
        source: 'submit',
        error,
      };
    }
  }

  /**
   * Webhookで受信したリカーリングトークンの
   * 登録状態を定期的に確認する。
   */
  private async pollRegistrationStatus(
    operationId: string,
    pollingToken: number,
    getSubmitFailedAt: () => number | null
  ): Promise<RegistrationCompletionResult> {
    const startedAt = Date.now();

    while (true) {
      const now = Date.now();
      const submitFailedAt =
        getSubmitFailedAt();

      /*
      * submit処理中は通常の10分間待機する。
      */
      if (
        submitFailedAt === null &&
        now - startedAt >=
          this.checkoutSubmitTimeoutMs
      ) {
        this.logClientEvent(
          'creditcard_registration_status_timeout',
          operationId,
          {
            reason: 'submit_pending',
            timeoutMilliseconds:
              this.checkoutSubmitTimeoutMs,
          }
        );

        return {
          status: 'timeout',
          source: 'webhook',
        };
      }

      /*
      * submit失敗後は短い待機時間へ切り替える。
      */
      if (
        submitFailedAt !== null &&
        now - submitFailedAt >=
          this.checkoutSubmitFailedTimeoutMs
      ) {
        this.logClientEvent(
          'creditcard_registration_status_timeout',
          operationId,
          {
            reason: 'submit_failed',
            timeoutMilliseconds:
              this.checkoutSubmitFailedTimeoutMs,
          }
        );

        return {
          status: 'timeout',
          source: 'webhook',
        };
      }

      /*
      * 登録処理が完了した場合や、
      * 新しい登録処理が開始された場合は終了する。
      */
      if (
        this.registrationPollingToken !==
          pollingToken ||
        this.isDestroying
      ) {
        return {
          status: 'cancelled',
          source: 'webhook',
        };
      }

      try {
        const response =
          await Axios.get<string>(
            `${this.univapayRegistrationStatusApiUrl}/${operationId}`,
            {
              dontDisplayErrorPage: true,
            }
          );

        const status =
          this.normalizeWebhookRegistrationStatus(
            response.data
          );

        this.logClientEvent(
          'creditcard_registration_status_received',
          operationId,
          {
            status,
          }
        );

        switch (status) {
          case 'successful':
            return {
              status: 'successful',
              source: 'webhook',
            };

          case 'failed':
            return {
              status: 'failed',
              source: 'webhook',
              error: new Error(
                '3Dセキュア認証またはリカーリングトークンの登録に失敗しました。'
              ),
            };

          case 'pending':
          default:
            break;
        }
      } catch (error) {
        /*
        * 状態確認APIの一時的な通信エラーでは
        * 登録処理全体を失敗にせず、次回ポーリングを継続する。
        */
        this.logClientError(
          'creditcard_registration_status_failed',
          error,
          operationId
        );
      }

      await this.wait(
        this.registrationPollingIntervalMs
      );
    }
  }

  /**
   * Webhook登録状態APIのレスポンスを正規化する。
   */
  private normalizeWebhookRegistrationStatus(
    value: unknown
  ): WebhookRegistrationStatus {
    const status =
      String(value ?? '')
        .trim()
        .toLowerCase();

    switch (status) {
      case 'successful':
        return 'successful';
      case 'failed':
        return 'failed';
      case 'pending':
      default:
        return 'pending';
    }
  }

  /**
   * submit処理とWebhook状態確認を並行実行し、
   * クレジットカード登録の最終結果を決定する。
   *
   * 成功は先に完了した方を採用する。
   *
   * submit側が失敗した場合は、WebViewが結果を
   * 受信できなかった可能性があるため、
   * Webhook側の結果が確定するまで待つ。
   */
  private async waitForRegistrationCompletion(
    submitTask: Promise<RegistrationCompletionResult>,
    webhookTask: Promise<RegistrationCompletionResult>
  ): Promise<RegistrationCompletionResult> {
    const firstResult =
      await Promise.race([
        submitTask,
        webhookTask,
      ]);

    /*
    * どちらかが成功した場合は、
    * その時点で登録成功とする。
    */
    if (firstResult.status === 'successful') {
      return firstResult;
    }

    /*
    * Webhook側が明確にfailedを返した場合は、
    * 3Dセキュアまたはトークン登録失敗として扱う。
    *
    * submitTaskは内部で例外をcatchしているため、
    * 後から完了しても未処理例外にはならない。
    */
    if (
      firstResult.source === 'webhook' &&
      firstResult.status === 'failed'
    ) {
      /*
      * Webhook側のエラーは詳細なエラーコードを
      * 持っていないため、submit側の結果を数秒待つ。
      *
      * submit側が失敗した場合は、
      * UnivaPayの詳細なエラーコードを優先する。
      */
      const submitResult =
        await this.waitForSubmitResultAfterWebhookFailure(
          submitTask,
          firstResult
        );

      return submitResult;
    }

    /*
    * submit側が先に失敗した場合でも、
    * Webhook側ではsuccessfulになる可能性があるため、
    * Webhook側の結果を待つ。
    */
    if (
      firstResult.source === 'submit' &&
      firstResult.status === 'failed'
    ) {
      const webhookResult = await webhookTask;

      if (
        webhookResult.status === 'successful'
      ) {
        return webhookResult;
      }

      /*
      * 元のsubmitエラーを表示する。
      */
      return firstResult;
    }

    /*
    * Webhook側が先にタイムアウトした場合、
    * submit処理が完了している可能性があるため
    * submit側の結果を確認する。
    */
    if (
      firstResult.source === 'webhook' &&
      firstResult.status === 'timeout'
    ) {
      const submitResult = await submitTask;

      if (
        submitResult.status === 'successful'
      ) {
        return submitResult;
      }

      return firstResult;
    }

    return firstResult;
  }

  /**
  * Webhookが先に失敗した場合に、
  * submit側の結果を一定時間だけ待つ。
  *
  * submit側が失敗した場合は、
  * より詳細なエラー情報を持つsubmit結果を優先する。
  */
  private async waitForSubmitResultAfterWebhookFailure(
    submitTask:
      Promise<RegistrationCompletionResult>,
    webhookResult:
      RegistrationCompletionResult
  ): Promise<RegistrationCompletionResult> {
    this.logClientEvent(
      'creditcard_registration_submit_result_wait_started',
      this.currentOperationId,
      {
        reason: 'webhook_failed',
        timeoutMilliseconds:
          this.webhookFailureSubmitWaitMs,
      }
    );

    const submitWaitTimeout =
      new Promise<RegistrationCompletionResult>(
        (resolve) => {
          window.setTimeout(() => {
            resolve(webhookResult);
          }, this.webhookFailureSubmitWaitMs);
        }
      );

    const result =
      await Promise.race([
        submitTask,
        submitWaitTimeout,
      ]);

    if (
      result.source === 'submit' &&
      result.status === 'failed'
    ) {
      this.logClientEvent(
        'creditcard_registration_submit_error_preferred',
        this.currentOperationId,
        {
          webhookStatus:
            webhookResult.status,
        }
      );

      return result;
    }

    /*
    * submit側が待機中に成功した場合は、
    * 登録成功として扱う。
    */
    if (
      result.source === 'submit' &&
      result.status === 'successful'
    ) {
      return result;
    }

    /*
    * 指定時間内にsubmitが完了しなかった場合は、
    * 先に確定したWebhook失敗を採用する。
    */
    return webhookResult;
  }

  /**
   * UnivaPay Checkoutへカード情報を送信し、
   * リカーリングトークンを取得する。
   */
  private async createRecurringToken(
    operationId: string
  ): Promise<string> {
    const univapayCheckout =
      (window as any).UnivapayCheckout;

    if (
      !univapayCheckout ||
      typeof univapayCheckout.update !== 'function'
    ) {
      throw new Error(
        'UnivapayCheckout.updateを使用できません。'
      );
    }

    if (
      !univapayCheckout ||
      typeof univapayCheckout.submit !== 'function'
    ) {
      throw new Error(
        'UnivapayCheckout.submitを使用できません。'
      );
    }

    const iframe =
      document.querySelector<HTMLIFrameElement>(
        '#checkout iframe'
      );

    if (!iframe) {
      throw new Error(
        'UnivaPay Checkout iframeが見つかりません。'
      );
    }

    this.logClientEvent(
      'univapay_submit_started',
      operationId
    );

    let result: UnivapayCheckoutResult;

    try {
      univapayCheckout.update(
        iframe,
        {
          metadata: {
            studentId: this.studentId,
            operationId,
          }
        },
      );

      result =
        await this.withTimeout<UnivapayCheckoutResult>(
          Promise.resolve(
            univapayCheckout.submit(iframe)
          ),
          this.checkoutSubmitTimeoutMs,
          'UnivaPayからの応答がタイムアウトしました。'
        );
    } catch (error) {
      this.logClientError(
        'univapay_submit_failed',
        error,
        operationId
      );

      throw error;
    }

    /*
     * 利用中のCheckout.jsのレスポンス形式に合わせ、
     * tokenを優先し、念のためidも確認する。
     */
    const recurringToken =
      result?.token ?? result?.id ?? '';

    if (!recurringToken) {
      this.logClientEvent(
        'univapay_submit_completed_without_token',
        operationId,
        {
          resultExists: Boolean(result),
          resultKeys:
            result && typeof result === 'object'
              ? Object.keys(result).join(',')
              : '',
        }
      );

      throw new Error(
        'UnivaPayからリカーリングトークンが返却されませんでした。'
      );
    }

    /*
     * リカーリングトークンの値自体はログに残さない。
     */
    this.logClientEvent(
      'univapay_token_received',
      operationId,
      {
        tokenReceived: true,
      }
    );

    return recurringToken;
  }

  /**
   * 自システムのカード登録APIをリトライ付きで呼び出す。
   */
  private async registerCreditcardWithRetry(
    request: UnivaPayRegisterCreditcardRequest,
    operationId: string
  ): Promise<void> {
    let lastError: unknown = null;

    for (
      let attempt = 1;
      attempt <= this.registerMaxAttempts;
      attempt++
    ) {
      this.logClientEvent(
        'creditcard_register_api_started',
        operationId,
        {
          attempt,
          maxAttempts: this.registerMaxAttempts,
        }
      );

      try {
        await Axios.post(
          this.univapayRegisterCreditcardUrl,
          request,
          {
            dontDisplayErrorPage: true,
            headers: {
              /*
               * バックエンド側でこの値を保存し、
               * 同一operationIdの処理を冪等化することを推奨。
               */
              'X-Idempotency-Key': operationId,
              'X-Operation-Id': operationId,
            },
          }
        );

        this.logClientEvent(
          'creditcard_register_api_completed',
          operationId,
          {
            attempt,
          }
        );

        return;
      } catch (error) {
        lastError = error;

        const normalizedError =
          this.normalizeError(error);

        const retryable =
          this.isRetryableRegistrationError(
            normalizedError
          );

        this.logClientError(
          'creditcard_register_api_failed',
          error,
          operationId,
          {
            attempt,
            retryable,
          }
        );

        if (
          !retryable ||
          attempt >= this.registerMaxAttempts
        ) {
          throw error;
        }

        const delayMilliseconds =
          this.calculateRetryDelay(attempt);

        this.logClientEvent(
          'creditcard_register_api_retry_wait',
          operationId,
          {
            attempt,
            delayMilliseconds,
          }
        );

        await this.wait(delayMilliseconds);
      }
    }

    throw (
      lastError ??
      new Error(
        'クレジットカード登録APIの実行に失敗しました。'
      )
    );
  }

  /**
   * APIエラーがリトライ可能か判定する。
   */
  private isRetryableRegistrationError(
    error: NormalizedError
  ): boolean {
    /*
     * HTTPレスポンス自体が存在しない場合は、
     * ネットワーク切断やレスポンス消失の可能性がある。
     */
    if (
      error.isNetworkError ||
      error.isTimeout ||
      error.httpStatus === undefined
    ) {
      return true;
    }

    return (
      error.httpStatus === 408 ||
      error.httpStatus === 425 ||
      error.httpStatus === 429 ||
      error.httpStatus >= 500
    );
  }

  /**
   * 登録エラーを表示する。
   */
  private async displayRegistrationError(
    error: unknown,
    modeText: string
  ): Promise<void> {
    const normalizedError = this.normalizeError(error);
    const univapayErrorCode = normalizedError.code;

    let errorCode = 999;
    let errorMessage =
      'クレジットカードの登録に失敗しました。入力内容をご確認ください。';
    let errorPrefix = 'E-100';

    if (univapayErrorCode !== undefined) {
      errorCode = univapayErrorCode;
      errorMessage =
        this.errorCodes.get(univapayErrorCode) ??
        errorMessage;
    } else if (
      normalizedError.isTimeout ||
      normalizedError.isNetworkError
    ) {
      errorCode = 998;
      errorPrefix = 'E-000';
      errorMessage =
        'クレジットカードの登録結果を確認できませんでした。通信状況をご確認のうえ、登録状況を確認してから再度お試しください。';
    } else if (
      normalizedError.httpStatus !== undefined
    ) {
      errorCode = normalizedError.httpStatus;
      errorPrefix = 'E-000';

      if (
        normalizedError.httpStatus >= 500
      ) {
        errorMessage =
          'クレジットカードの登録処理で一時的なエラーが発生しました。時間を空けて再度お試しください。';
      } else {
        errorMessage =
          'クレジットカード情報を登録できませんでした。入力内容をご確認ください。';
      }
    }

    await this.$confirm(
      `${errorMessage}<br>(Status: ${errorPrefix}-${errorCode})`,
      `クレジットカード${modeText}`,
      {
        confirmButtonText: 'OK',
        type: 'error',
        showCancelButton: false,
        dangerouslyUseHTMLString: true,
      }
    );
  }

  /**
   * Promiseにタイムアウトを設定する。
   */
  private async withTimeout<T>(
    promise: Promise<T>,
    timeoutMs: number,
    timeoutMessage: string
  ): Promise<T> {
    let timerId: number | null = null;

    const timeoutPromise =
      new Promise<never>((_, reject) => {
        timerId = window.setTimeout(() => {
          reject(
            new OperationTimeoutError(
              timeoutMessage
            )
          );
        }, timeoutMs);
      });

    try {
      return await Promise.race([
        promise,
        timeoutPromise,
      ]);
    } finally {
      if (timerId !== null) {
        window.clearTimeout(timerId);
      }
    }
  }

  /**
   * リトライ待機時間を計算する。
   *
   * 1回目失敗後: 約1秒
   * 2回目失敗後: 約2秒
   * 3回目失敗後: 約4秒
   *
   * 同時アクセスが集中しないように少量のランダム値を加える。
   */
  private calculateRetryDelay(
    attempt: number
  ): number {
    const exponentialDelay = Math.min(
      1000 * Math.pow(2, attempt - 1),
      8000
    );

    const jitter =
      Math.floor(Math.random() * 300);

    return exponentialDelay + jitter;
  }

  /**
   * エラーを共通形式へ変換する。
   */
  private normalizeError(
    error: any
  ): NormalizedError {
    const message =
      typeof error?.message === 'string'
        ? error.message
        : String(error ?? 'Unknown error');

    const lowerMessage =
      message.toLowerCase();

    const httpStatus =
      typeof error?.response?.status === 'number'
        ? error.response.status
        : undefined;

    const code =
      typeof error?.code === 'number'
        ? error.code
        : typeof error?.response?.data?.code ===
            'number'
          ? error.response.data.code
          : undefined;

    return {
      name:
        typeof error?.name === 'string'
          ? error.name
          : 'UnknownError',

      message,

      code,

      httpStatus,

      isNetworkError:
        !error?.response &&
        (
          lowerMessage.includes(
            'network error'
          ) ||
          lowerMessage.includes(
            'failed to fetch'
          ) ||
          lowerMessage.includes(
            'network request failed'
          )
        ),

      isTimeout:
        error instanceof OperationTimeoutError ||
        lowerMessage.includes('timeout') ||
        lowerMessage.includes(
          'タイムアウト'
        ) ||
        error?.code === 'ECONNABORTED',
    };
  }

  /**
   * 操作識別子を生成する。
   */
  private createOperationId(): string {
    const cryptoObject =
      window.crypto as Crypto | undefined;

    if (
      cryptoObject &&
      typeof cryptoObject.randomUUID ===
        'function'
    ) {
      return cryptoObject.randomUUID();
    }

    /*
     * randomUUIDに対応していない古いWebView向け。
     */
    return [
      Date.now().toString(36),
      Math.random()
        .toString(36)
        .substring(2, 10),
      Math.random()
        .toString(36)
        .substring(2, 10),
    ].join('-');
  }

  /**
   * Checkoutにより生成されたiframeを削除する。
   */
  private cleanupCheckout(): void {
    const checkout =
      document.getElementById('checkout');

    if (!checkout) {
      return;
    }

    const iframes =
      checkout.querySelectorAll('iframe');

    iframes.forEach((iframe) => {
      iframe.parentNode?.removeChild(iframe);
    });
  }

  /**
   * ブラウザーまたはWebViewのライフサイクルイベントを登録する。
   */
  private addBrowserLifecycleEventListeners(): void {
    document.addEventListener(
      'visibilitychange',
      this.onVisibilityChange
    );

    window.addEventListener(
      'pagehide',
      this.onPageHide
    );

    window.addEventListener(
      'pageshow',
      this.onPageShow
    );

    window.addEventListener(
      'online',
      this.onNetworkOnline
    );

    window.addEventListener(
      'offline',
      this.onNetworkOffline
    );
  }

  /**
   * ブラウザーまたはWebViewのライフサイクルイベントを解除する。
   */
  private removeBrowserLifecycleEventListeners(): void {
    document.removeEventListener(
      'visibilitychange',
      this.onVisibilityChange
    );

    window.removeEventListener(
      'pagehide',
      this.onPageHide
    );

    window.removeEventListener(
      'pageshow',
      this.onPageShow
    );

    window.removeEventListener(
      'online',
      this.onNetworkOnline
    );

    window.removeEventListener(
      'offline',
      this.onNetworkOffline
    );
  }

  private onVisibilityChange = (): void => {
    this.logClientEvent(
      'document_visibility_changed',
      this.currentOperationId,
      {
        visibilityState:
          document.visibilityState,
        registrationStatus:
          this.registrationStatus,
      }
    );
  }

  private onPageHide = (
    event: PageTransitionEvent
  ): void => {
    this.logClientEvent(
      'webview_page_hidden',
      this.currentOperationId,
      {
        persisted: event.persisted,
        registrationStatus:
          this.registrationStatus,
      }
    );
  }

  private onPageShow = (
    event: PageTransitionEvent
  ): void => {
    this.logClientEvent(
      'webview_page_shown',
      this.currentOperationId,
      {
        persisted: event.persisted,
        registrationStatus:
          this.registrationStatus,
      }
    );
  }

  private onNetworkOnline = (): void => {
    this.logClientEvent(
      'network_online',
      this.currentOperationId,
      {
        registrationStatus:
          this.registrationStatus,
      }
    );
  }

  private onNetworkOffline = (): void => {
    this.logClientEvent(
      'network_offline',
      this.currentOperationId,
      {
        registrationStatus:
          this.registrationStatus,
      }
    );
  }

  /**
   * クライアントイベントをログ出力する。
   *
   * Flutter WebView側でJavaScriptコンソールを捕捉してアプリログに記録。
   */
  private logClientEvent(
    eventName: string,
    operationId: string | null,
    properties: ClientLogProperties = {}
  ): void {
    const logData = {
      category: 'UnivaPayCreditcard',
      eventName,
      operationId,
      timestamp: new Date().toISOString(),
      visibilityState:
        document.visibilityState,
      online: navigator.onLine,
      registrationStatus:
        this.registrationStatus,
      properties,
    };

    /*
     * recurringToken、カード番号、セキュリティーコードなどは
     * 絶対にログへ出力しない。
     */
    // tslint:disable-next-line: no-console
    console.info(
      '[UnivaPayCreditcard]',
      JSON.stringify(logData)
    );
  }

  /**
   * クライアントエラーをログ出力する。
   */
  private logClientError(
    eventName: string,
    error: unknown,
    operationId: string | null,
    properties: ClientLogProperties = {}
  ): void {
    const normalizedError =
      this.normalizeError(error);

    const logData = {
      category: 'UnivaPayCreditcard',
      eventName,
      operationId,
      timestamp: new Date().toISOString(),
      visibilityState:
        document.visibilityState,
      online: navigator.onLine,
      registrationStatus:
        this.registrationStatus,
      error: {
        name: normalizedError.name,
        message: normalizedError.message,
        code: normalizedError.code,
        httpStatus:
          normalizedError.httpStatus,
        isNetworkError:
          normalizedError.isNetworkError,
        isTimeout:
          normalizedError.isTimeout,
      },
      properties,
    };

    // tslint:disable-next-line: no-console
    console.error(
      '[UnivaPayCreditcard]',
      JSON.stringify(logData)
    );
  }

  private wait(
    milliseconds: number
  ): Promise<void> {
    return new Promise<void>((resolve) => {
      window.setTimeout(
        resolve,
        milliseconds
      );
    });
  }
}
